export default {
    'remaining-materials': 'المواد المتبقية',
    'ravages': 'إتلاف',
    'free-distribution': 'توزيع مجاني',
    'returnable': 'مرتجع',
    'modify-transfer': 'تعديل مناقلة',
    'stocktaking': 'تسويةالجرد',
    'reason': 'السبب'
}